import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { TextInput, Form, Button } from 'components/common';
import { withTranslation } from 'language/i18n';
import { emailValidator } from 'utils/formValidators';
import { forgotPassword } from 'models/user';
import { StatusContext } from 'contexts/statusContext';

const EmailEnterence = ({ t, email, setEmail }) => {
  const router = useRouter();

  const { setErrorState } = useContext(StatusContext);

  const [onResponse, setOnResponse] = useState(false);

  const onFormSubmit = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        await forgotPassword(email);
        router.push({
          pathname: '/forgot-password/email-verification',
          query: {
            email,
          },
        });
      } catch (error) {
        console.log('emailEnterenceErr', error);
        if (error.status) {
          setErrorState({
            title: t('alert'),
            text: error.message,
            buttonText: t('close'),
            onClickButton: () => setErrorState({}),
          });
        }
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <div className="col-md-10 col-lg-8 offset-lg-1 mt-5 mt-md-0">
      <Form layout="vertical" onFinish={onFormSubmit}>
        <div className="fs-22 fw-900 mb-3">{t('forgotYourPassword')}</div>
        <div className="mb-5">Üyelik bilgilerinizin kayıtlı olduğu e-posta adresini, aşağıdaki kutuya giriniz.</div>

        <div className="row mb-3">
          <div className="col-15 col-sm-15 mb-3 mb-sm-0">
            <TextInput
              name="email"
              type="email"
              value={email}
              placeholder={t('email')}
              validator={emailValidator}
              onChange={({ value }) => setEmail(value)}
            />
          </div>
        </div>

        <Button
          loading={onResponse}
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center mt-5 mb-5"
          label={t('resetPassword')}
        />

      </Form>
    </div>
  );
};

EmailEnterence.propTypes = {
  t: PropTypes.func,
  email: PropTypes.string,
  setEmail: PropTypes.func,

};

export default withTranslation('common')(EmailEnterence);
